import { useState } from 'react'
import { useSelector } from 'react-redux'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useGetStatisticsQuery } from '../../../features/generalAlerts/generalAlertsSlice'
import '../home.scss'

const AlertsByRuleInstanceIds = () => {
  const type = 'by_rule_instance'
  const { t } = useTranslation(['messages', 'common'])

  const { period } = useSelector((state) => state.statistics)
  const { data: statisticsResponse, isFetching, isLoading } = useGetStatisticsQuery({ type, period })
  const { data: statistics } = statisticsResponse || { data: [] }
  const [sortModel, setSortModel] = useState([{ field: 'ruleId', sort: 'desc' }])

  const columns = [
    { field: 'ruleId', headerName: 'Rule' },
    {
      field: 'maskId',
      headerName: 'Instance',
      renderCell: ({ value }) => value,
    },
    { field: 'total', headerName: t(`messages:statistics.alerts.states.total`) },
    { field: 'pending', headerName: t(`messages:statistics.alerts.states.pending`) },
    { field: 'reviewing', headerName: t(`messages:statistics.alerts.states.reviewing`) },
    { field: 'closed', headerName: t(`messages:statistics.alerts.states.closed`) },
  ]

  return (
    <Paper elevation={0} className="home-alerts-table">
      <Typography variant="text4">{t(`messages:statistics.alerts.title.${type}`)}</Typography>

      <DataGridPro
        getRowId={(row) => `${row.ruleInstanceId}-${row.ruleId}`}
        rows={statistics || []}
        columns={columns}
        disableColumnMenu
        hideFooterPagination
        loading={isFetching || isLoading}
        sortModel={sortModel}
        onSortModelChange={(sortModel) => setSortModel(sortModel)}
        hideFooter
        autoHeight
      />
    </Paper>
  )
}

export default AlertsByRuleInstanceIds
